import React, { useEffect, useState } from 'react';
import InfoDialog from '../../../components/shared/InfoDialog';
import CusInput from '../../../components/material-ui/CusInput';
import { API_USERS } from '../../../api/users';
import { useDispatch } from 'react-redux';
import { updateUserResult } from '../../../store/apps/usersSlice';
import { validateEmail } from '../../../utils';
import useToast from '../../../hooks/useToast';

export default function ChangeEmailModal({ open, closeModal, user, setSelectUserFull }) {
  const dispatch = useDispatch();
  const { errorToast } = useToast();
  const emailDefault = user.emailAddress;
  const userLogin = user.login;
  const [email, setEmail] = useState(emailDefault);

  const onSaveClick = () => {
    const isValid = validateEmail(email);
    if (!isValid) {
      errorToast('Invalid email address');
      return;
    }

    API_USERS.info
      .changeEmail({ userId: user.userId, newEmail: email })
      .then((e) => {
        setSelectUserFull((prev) => ({ ...prev, emailAddress: email, emailConfirmed: false }));
        dispatch(updateUserResult({ id: user.userId, dataIndx: 9, value: email }));

        closeModal();
      })
      .catch(console.error);
  };

  useEffect(() => {
    setEmail(emailDefault);
  }, [userLogin, emailDefault]);

  return (
    <InfoDialog
      open={open}
      onClose={closeModal}
      title={'Change Email'}
      maxWidth="xs"
      onSaveClick={onSaveClick}
      saveText="Confirm">
      <CusInput
        label={'Email'}
        value={email}
        autoFocus={open}
        onChange={(e) => setEmail(e.target.value)}
      />
    </InfoDialog>
  );
}
